import React, { useRef } from 'react';
import Section from './common/Section';
import emailjs from '@emailjs/browser';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import mobilePhone2 from '../assets/mobilePhone2.png';
import {
  FaFacebook,
  FaLinkedinIn,
  FaTwitter,
  FaWhatsapp,
} from 'react-icons/fa';

function Contact() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        process.env.REACT_APP_YOUR_SERVICE_ID,
        process.env.REACT_APP_YOUR_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_YOUR_PUBLIC_KEY
      )
      .then(
        (result) => {
          if (result.status === 200) {
            toast.success('Message Sent Successfully', {
              position: 'top-center',
              autoClose: 1000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: 'light',
            });

            e.target.reset();
          } else {
            toast.error('Something went wrong', {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        },
        (error) => {
          console.log(error.text);
          toast.error(error.text);
        }
      );
  };
  const SOCIAL = [
    {
      id: 1,
      link: 'https://twitter.com/notableprince',
      icon: <FaTwitter />,
    },
    {
      id: 2,
      link: 'https://www.facebook.com/msbtrooper',
      icon: <FaFacebook />,
    },
    {
      id: 3,
      link: 'https://www.linkedin.com/in/ayodeji-adebolu-75282418b/',
      icon: <FaLinkedinIn />,
    },
    {
      id: 4,
      link: 'https://wa.me/+2348100987235',
      icon: <FaWhatsapp />,
    },
  ];

  return (
    <Section
      title="Contact 📞☎📲"
      subtitle="These are the ways you can get in touch with me. Hope to hear from you soon: "
    >
      <div className="flex flex-col items-center justify-center gap-8 text-center">
        <div>
          <img
            src={mobilePhone2}
            loading="lazy"
            alt="contact info"
            className="w-32 h-32"
          />
        </div>
        <div>
          <p className="max-w-xs md:max-w-lg font-extralight">
            I am open to talk regarding freelancing or full-time opportunities.
            Fell free to contact me using your preferred medium.
          </p>
        </div>
        <div className="flex w-full items-center justify-evenly text-3xl">
          {SOCIAL.map(({ id, link, icon }) => (
            <a
              key={id}
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className="duration-200 ease-in-out hover:text-rose-600"
            >
              {icon}
            </a>
          ))}
        </div>

        {/* FORM */}
        <div className="p-8 text-left w-full">
          <form
            action="https://formsubmit.co/agbamosemark@gmail.com"
            method="post"
            ref={form}
            onSubmit={sendEmail}
          >
            <div className="gap-4 w-full">
              <div className="flex flex-col my-2">
                <label className="capitalize text-sm py-2 font-extralight">
                  name
                </label>
                <input
                  type="text"
                  name="user_name"
                  className="border-2 rounded-lg p-3 flex focus:outline-none border-gray-400 dark:bg-gray-900 dark:text-white"
                  required
                />
              </div>

              <div className="flex flex-col my-2">
                <label className="capitalize text-sm py-2 font-extralight">
                  phone number
                </label>
                <input
                  type="tel"
                  name="user_phone"
                  className="border-2 rounded-lg p-3 flex focus:outline-none border-gray-400 dark:bg-gray-900 dark:text-white"
                  required
                />
              </div>

              <div className="flex flex-col my-2">
                <label className="capitalize text-sm py-2 font-extralight">
                  email
                </label>
                <input
                  type="email"
                  name="user_email"
                  className="border-2 rounded-lg p-3 flex focus:outline-none border-gray-400 dark:bg-gray-900 dark:text-white"
                  required
                />
              </div>

              <div className="flex flex-col my-2">
                <label className="capitalize text-sm py-2 font-extralight">
                  message
                </label>

                <textarea
                  name="message"
                  rows="10"
                  className="border-2 rounded-lg p-3 flex focus:outline-none border-gray-400 dark:bg-gray-900 dark:text-white resize-none"
                  required
                ></textarea>
              </div>
            </div>

            <div className="flex items-center justify-center">
              <button
                type="submit"
                value="send"
                className="my-8 bg-gradient-to-r from-rose-600 to-teal-500 text-white px-6 py-3 uppercase rounded-md tracking-wider cursor-pointer hover:scale-105 duration-200"
                onClick={toast.success}
              >
                send message
              </button>
            </div>
            <ToastContainer className="text-center italic font-bold text-white rounded-xl  dark:text-white" />
          </form>
        </div>
      </div>
    </Section>
  );
}

export default Contact;
